import { Pipe, PipeTransform } from '@angular/core';
import { EnabledAuthMethod } from '../../models/settings/enabled-auth-method';
import { AuthMethod } from '../../models/settings/auth-method';

@Pipe({
    name: 'sortAuthMethods',
    standalone: true
})
export class SortAuthMethodsPipe implements PipeTransform {

    transform<T extends AuthMethod | EnabledAuthMethod>(authMethods: T[] | null | undefined): T[] {
        if (!authMethods || !authMethods.length) {
            return [];
        }

        const sorting = ['mouse', 'mouse_preview', 'smstan', 'smstan_preview', 'sso', 'sso_preview', 'idin', 'idin_preview', 'irma', 'irma_preview', 'digid', 'digid_preview', 'checkedid', 'csc', 'csc_preview', 'documenttemplate', 'document_anchors', 'certificate'];
        const copy = [...authMethods];

        if (typeof copy[0] === 'string') {
            return (copy as unknown as AuthMethod[]).sort((a, b) => {
                return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
            }) as unknown as T[];
        } else {
            return (copy as unknown as EnabledAuthMethod[]).sort((a, b) => {
                return sorting.indexOf(a.authenticationMethod) > sorting.indexOf(b.authenticationMethod) ? 1 : -1;
            }) as unknown as T[];
        }
    }
}
